import { useAppContext } from "qpr-base/context/AppCtxProvider";
import usePeriods from "../hooks/model/usePeriods";

export const usePeriod = () => {
  const ctx = useAppContext();
  const { data, isLoading } = usePeriods();

  if (data) {
    const selectedPeriod = data.filter((p) => p.name === ctx.period).pop();

    if (selectedPeriod) {
      return data.filter((per) => {
        return (
          per.startdate <= selectedPeriod?.startdate &&
          per.enddate >= selectedPeriod.startdate
        );
      });
    }
  }
  return [];
};
